export const Mail = (props) => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M4 4.96143H20C21.1 4.96143 22 5.86143 22 6.96143V18.9614C22 20.0614 21.1 20.9614 20 20.9614H4C2.9 20.9614 2 20.0614 2 18.9614V6.96143C2 5.86143 2.9 4.96143 4 4.96143Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
      <path d='M22 6.96143L12 13.9614L2 6.96143' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
    </svg>
  )
}
